import { CustomError } from './CustomError';

export class ProductNotFoundError extends CustomError {
	description = 'Twitch product sku not found';
	name = 'ProductNotFoundError';
}
